import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "order-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", {
  role: "separator",
  "aria-orientation": "horizontal",
  class: "v-divider",
  theme: "light"
}, null, -1)

import {computed, ref, watch} from 'vue';
import FilterList from '@/components/FilterList.vue';
import ErrorComp from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import Pagination from '@/components/Pagination.vue';
import WarehouseSelect from '@/components/WarehouseSelect.vue';
import OrderListItem from '@/components/Order/OrderListItem.vue';
import router from '@/router';
import {RouteLocationRaw as RawLocation} from 'vue-router';
import useOrdersStore from '@/store/orders';
import {useStorage} from '@/composables/storage';
import {useFilterSort} from '@/composables/filterSort';
import {useScanner} from '@/store/scanner';
import {storeToRefs} from 'pinia';



export default /*#__PURE__*/_defineComponent({
  __name: 'OrderList',
  emits: {'close': () => true},
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useOrdersStore();
const emit = __emit;
const scanner = useScanner();
const {filters, save} = useFilterSort(store, emit);
const {dataStorageModule, data, error, loading, dataDisplayFilters} = storeToRefs(store);
useStorage(store);
const searchDebounceTimeout = ref<number | null>(null);
let scanning = false;

const fulltextSearch = computed({
  get(): string {
    return filters.value.Fulltext$Fulltext.words.join(' ');
  },
  set(val: string) {
    if (!val) {
      filters.value.Fulltext$Fulltext.words = [];
      return;
    }
    filters.value.Fulltext$Fulltext.words = val.split(' ');
  },
});

function navigate(to: RawLocation) {
  router.push(to).catch(console.error);
}

function doSearch() {
  if (searchDebounceTimeout.value) clearTimeout(searchDebounceTimeout.value);
  save();
  scanning = false;
}

scanner.addScanListener(async (event) => {
  if (scanning) return;
  scanning = true;

  fulltextSearch.value = event.data;
  doSearch();
});

watch(fulltextSearch, (newVal: string, oldVal: string) => {
  if (newVal === oldVal || newVal.length < 3) return;
  if (searchDebounceTimeout.value) clearTimeout(searchDebounceTimeout.value);

  searchDebounceTimeout.value = setTimeout(() => {
    doSearch();
  }, 500);
});

__expose({
  emit,
  filters, save,
  FilterList,
  Error: ErrorComp,
  dataStorageModule, data, error, loading, dataDisplayFilters,
  searchDebounceTimeout,
  Loading,
  Pagination,
  WarehouseSelect,
  OrderListItem,
  navigate,
  doSearch,
  fulltextSearch,
  store,
});

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, {
      class: "py-1 px-3 bg-grey-lighten-4",
      fluid: ""
    }, {
      default: _withCtx(() => [
        _createVNode(WarehouseSelect),
        (!_unref(store).loading && _unref(store).displayFilters.length > 0)
          ? (_openBlock(), _createBlock(FilterList, {
              key: 0,
              store: _unref(store)
            }, null, 8, ["store"]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }),
    (!_unref(store).loading && !_unref(store).error)
      ? (_openBlock(), _createBlock(_component_v_list, {
          key: 0,
          lines: "two",
          class: "pa-0 border-t"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (order) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: order.Nummer
              }, [
                _createVNode(OrderListItem, { order: order }, null, 8, ["order"]),
                _hoisted_2
              ], 64))
            }), 128)),
            _createVNode(_component_v_container, {
              fluid: "",
              class: "mb-10"
            }, {
              default: _withCtx(() => [
                _createVNode(Pagination, {
                  module: _unref(store).$id
                }, null, 8, ["module"])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }))
      : (_unref(store).error)
        ? (_openBlock(), _createBlock(_component_v_container, {
            key: 1,
            class: "py-1",
            fluid: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(error), {
                module: _unref(store).$id
              }, null, 8, ["module"])
            ], undefined, true),
            _: 1
          }))
        : (_openBlock(), _createBlock(Loading, { key: 2 })),
    _createVNode(_component_v_btn, {
      style: {"z-index":"1"},
      class: "ma-3",
      icon: "",
      position: "fixed",
      location: "right bottom",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate({ name: 'order_delivery' }))),
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [
            _createTextVNode("mdi-plus")
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})